import { redirect } from "@tanstack/react-router";

import type { RegisteredRouter, RouteById } from "@tanstack/react-router";

type AppContext = RouteById<RegisteredRouter["routeTree"], "/_app">["types"]["allContext"];

export function requireMedical({ context }: { context: AppContext }) {
	if (context.user.role !== "medical") {
		redirect({ to: "/", throw: true });
	}
}
